// История браузера для SPA без react-router: разделы и модалки верхнего уровня.
// Разделы пишет App.js (pushState с { rvView }), модалки — хук useModalHistory ({ rvModal: глубина }).
import { useEffect, useRef } from "react";

// Стек функций закрытия открытых модалок (модуль-синглтон)
const modalStack = [];

function currentUrl() {
  return window.location.pathname + window.location.search;
}

// Открытие модалки: создаёт запись истории. Возвращает release() — вызвать при закрытии из UI.
export function openModalHistory(closeFn) {
  const base = window.history.state || {};
  window.history.pushState({ ...base, rvModal: modalStack.length + 1 }, "", currentUrl());
  const entry = { closeFn };
  modalStack.push(entry);
  return function release() {
    const idx = modalStack.indexOf(entry);
    if (idx === -1) return; // уже закрыта жестом "назад" или навигацией по разделам
    modalStack.splice(idx, 1);
    window.history.back(); // убираем запись модалки из истории
  };
}

// Из popstate: закрывает модалки глубже state.rvModal. true — событие обработано модалками.
export function popModalsToDepth(state) {
  const depth = (state && state.rvModal) || 0;
  let handled = false;
  while (modalStack.length > depth) {
    const entry = modalStack.pop();
    try { entry.closeFn(); } catch (e) { /* noop */ }
    handled = true;
  }
  return handled;
}

// Навигация по разделам при открытых модалках: закрыть все без history.back()
export function closeAllModalsSilently() {
  const had = modalStack.length;
  while (modalStack.length) {
    const entry = modalStack.pop();
    try { entry.closeFn(); } catch (e) { /* noop */ }
  }
  return had;
}

// Хук для модалок: пока isOpen — запись в истории, жест "назад" закрывает модалку первой
export function useModalHistory(isOpen, closeFn) {
  const closeRef = useRef(closeFn);
  closeRef.current = closeFn;
  useEffect(() => {
    if (!isOpen) return undefined;
    const release = openModalHistory(() => closeRef.current());
    return release;
  }, [isOpen]);
}
